<template>
  <div class="cgs-grid">
    <label v-for="item in options" :key="item[itemKey]" class="cgs-item">
      <input
        type="checkbox"
        class="cgs-checkbox"
        :checked="isChecked(item)"
        @change="toggle(item)"
      />
      {{ item[itemLabel] }}
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    options: {
      type: Array,
      default: () => [],
    },
    itemKey: {
      type: String,
      default: "id",
    },
    itemLabel: {
      type: String,
      default: "label",
    },
  },
  methods: {
    isChecked(item) {
      return this.value.some((el) => el[this.itemKey] === item[this.itemKey]);
    },
    toggle(item) {
      const next = [...this.value];
      const idx = next.findIndex(
        (el) => el[this.itemKey] === item[this.itemKey],
      );
      if (idx === -1) next.push(item);
      else next.splice(idx, 1);
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.cgs-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem 1rem;
  padding: 0.5rem 0;
}

.cgs-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  color: #333;
  font-size: 13px;
}

.cgs-checkbox {
  width: 18px;
  height: 18px;
  accent-color: #1976d2;
  cursor: pointer;
  flex-shrink: 0;
}
</style>
